import { Box, xcss } from '@atlaskit/primitives';
import { getGridTemplateColumns } from '@databases/frontend/TableLayout';
import { Database } from '@databases/types/database';
import { HALF_ROW_SELECT_BUTTON_WIDTH } from '@databases/utils/constants';
import React, { FunctionComponent } from 'react';

import QuickCalculationsSelect from './QuickCalculationSelect';

interface QuickCalculationsRowProps {
  columnWidths: number[];
  database: Database;
  containerWidth: number;
  canEditContent: boolean;
}

const getQuickCalculationSelectStyles = (width: number) => {
  return xcss({
    padding: 'space.0',
    width: `${width}px`,
  });
};

const QuickCalculationsRow: FunctionComponent<QuickCalculationsRowProps> = ({
  columnWidths,
  database,
  canEditContent,
}) => {
  return (
    <tr
      style={{
        display: 'grid',
        gridTemplateColumns: getGridTemplateColumns(columnWidths),
        marginLeft: `${HALF_ROW_SELECT_BUTTON_WIDTH}px`,
      }}
    >
      {database.fields.map((fieldId) => {
        const widthIndex = database.fields.indexOf(fieldId);

        return (
          <Box
            as="td"
            key={fieldId}
            xcss={getQuickCalculationSelectStyles(columnWidths[widthIndex])}
          >
            <QuickCalculationsSelect
              fieldId={fieldId}
              database={database}
              width={columnWidths[widthIndex]}
              canEditContent={canEditContent}
            />
          </Box>
        );
      })}
    </tr>
  );
};

export default QuickCalculationsRow;
